import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import './axios'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Vidle from 'v-idle'
import VueTouchKeyboard from "vue-touch-keyboard";
import VueMask from 'v-mask'
import Embed from 'v-video-embed'
import VideoBg from 'vue-videobg'
import myVideo from 'vue-video'
//import GmapVue from 'gmap-vue'
 
Vue.component('video-bg', VideoBg, myVideo)

Vue.use(Embed);

Vue.use(VueMask)
 
Vue.use(VueTouchKeyboard);

Vue.use(Vidle)



/* Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places', // only include 'places' if you're adding address search
  },
}) */



Vue.config.productionTip = false
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')